import type { List, ListStage } from 'app/generated/graphql'
import type { SystemListDef } from 'app/types/navigation'

export function splitSystemStages(
  stages: readonly ListStage[],
  exitStageNames: readonly string[] | undefined,
): { lanes: ListStage[]; exits: ListStage[] } {
  const exitNames = new Set(exitStageNames ?? [])
  return {
    lanes: stages.filter((stage) => !exitNames.has(stage.name)),
    exits: stages.filter((stage) => exitNames.has(stage.name)),
  }
}

// `system` comes back null, not false, on a stage a workspace added.
export function hasPracticeStage(list: Pick<List, `stages`>): boolean {
  return (list.stages ?? []).some((stage) => !stage.system)
}

export function snoozeExclusionTerm(contactIds: readonly string[]): string | undefined {
  if (contactIds.length === 0) return undefined
  return `NOT id:(${contactIds.map((id) => `"${id}"`).join(` OR `)})`
}

export function setupSkipSettingKey(def: Pick<SystemListDef, `slug`>, workspaceId: string): string {
  return `systemListSetupSkipped-${def.slug}-${workspaceId}`
}
